import React from "react";
import { Analytics } from "@vercel/analytics/react";

// importing styles
import "./App.css";

// importing pages
import HomePage from "./pages/home-page/home-page";

// importing components
import CursorComponent from "./components/cursor-component/cursor-component";

function App() {
	return (
		<>
			<CursorComponent />
			<HomePage />
			<Analytics />
		</>
	);
}

export default App;
